import { render, staticRenderFns } from "./WebSocket.vue?vue&type=template&id=8a5404c4&scoped=true"
import script from "./WebSocket.vue?vue&type=script&lang=js"
export * from "./WebSocket.vue?vue&type=script&lang=js"
import style0 from "./WebSocket.vue?vue&type=style&index=0&id=8a5404c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5404c4",
  null
  
)

export default component.exports